import { Phone } from "lucide-react";
import { CONTACT } from "@/data/content";

export const FloatingActions = () => (
  <div className="fixed bottom-6 right-5 z-50 flex flex-col gap-3">
    <a
      data-testid="float-call"
      href={`tel:${CONTACT.phoneRaw}`}
      aria-label="Appeler Moum's"
      className="h-14 w-14 rounded-full bg-strawberry flex items-center justify-center shadow-hover hover:scale-110 transition-transform"
    >
      <Phone size={24} className="text-white" />
    </a>
  </div>
);
